import React, { useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { StyledContainer } from './styled';
import TeamSquadContainer from './components/TableContainer';
import StrategyContainer from './components/StrategyContainer';
import Development from './components/Development';

export default function Team() {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/team' || location.pathname === '/team/') {
      history.push('/team/strategy');
    }
  }, [history, location.pathname]);

  return (
    <>
      <StyledContainer $strategy={location.pathname === "/team/strategy"}>
        <Switch>
          <Route path="/team/strategy" component={StrategyContainer} />
          <Route path="/team/squad" component={TeamSquadContainer} />
          <Route path="/team/development" component={Development} />
        </Switch>
      </StyledContainer>
    </>
  );
}
